import { render, staticRenderFns } from "./FriendList.vue?vue&type=template&id=38986f42&scoped=true"
import script from "./FriendList.vue?vue&type=script&lang=js"
export * from "./FriendList.vue?vue&type=script&lang=js"
import style0 from "./FriendList.vue?vue&type=style&index=0&id=38986f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38986f42",
  null
  
)

export default component.exports